export const ADMIN="ADMIN"
export const OPERATION="OPERATION"
export const MERCHANT="MERCHANT"
export const FINANCE="FINANCE"